import { makeStyles } from '@material-ui/core';

const baseCssBooking = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'transparent',
      boxShadow: 'unset',
      flex: '1',
    },
    '& .MuiDialog-container': {
      position: 'fixed',
      left: '6.25rem',
      right: '6.26rem',
      top: '3.438rem',
      bottom: '3.438rem',
      height: 'unset',
    },
    '& .MuiDialog-paper': {
      margin: '0',
      maxHeight: 'unset',
      maxWidth: 'unset',
    },
  },
  root: {
    width: '100%',
    maxWidth: '80rem',
    display: 'flex',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    background: '#fff',
    height: '100%',
    overflow: 'auto',
    minWidth: '55rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    borderBottom: 'solid 1px #e4e7eb',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    padding: '1.938rem 0 1.5rem 0rem',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    // marginRight: '0.625rem',
    marginRight: '-10px',
  },
  container: {
    flex: '1',
    overflow: 'auto',
    padding: '0 1.5rem 0 1.53rem',
  },
  bottom: {
    height: '4.438rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomDeleteBtn: {
    flexBasis: '50%',
    fontFamily: 'NotoSans-Medium',
    height: '2.688rem',
    border: 'solid 1.5px #538fff',
    borderRadius: '0.625rem',
    background: '#f5faff',
    color: '#538fff',
    fontSize: '1rem',
    fontWeight: '500',
    maxWidth: '20rem',
  },
  bottomSaveBtn: {
    flexBasis: '50%',
    fontFamily: 'NotoSans-Medium',
    height: '2.688rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
    maxWidth: '20rem',
  },
  labelText: {
    fontFamily: 'NotoSans-Medium',
    width: '50%',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#7d86a9',
  },
  inputText: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    width: '50%',
    fontFamily: 'NotoSans-Medium',
    height: '3.5rem',
    lineHeight: '3.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    backgroundColor: '#fff',
    padding: '0 1.25rem',
    color: '#2e4469',
    fontSize: '1rem',
    '& .MuiInputBase-input': {
      height: '100%',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  flexRowMargin: {
    display: 'flex',
    '& > :nth-child(1)': {
      marginRight: '1.25rem',
    },
  },
  gender: {
    display: 'flex',
    flexBasis: '50%',
    '& :nth-child(1)': {
      borderRadius: '0.625rem 0 0 0.625rem',
    },
    '& :nth-child(2)': {
      borderRadius: '0 0.625rem 0.625rem 0',
    },
  },
  genderBtn: {
    fontFamily: 'NotoSans-Medium',
    flexBasis: '50%',
    borderRadius: '0.625rem',
    fontSize: '1rem',
    color: '#2e4469',
    background: '#fff',
    border: 'solid 1px #e4e7eb',
  },
  selectGender: {
    background: '#538fff',
    color: '#fff',
    border: '0',
  },
  dateIcon: {
    fontSize: '1.125rem',
    color: '#538fff',
    padding: '0.8rem',
  },
  others: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  select: {
    '& .MuiSelect-iconOutlined': {
      color: '#538fff',
    },
  },
  checkBox: {
    marginLeft: '0rem',
    '& .MuiButtonBase-root': {
      padding: '0',
      paddingRight: '0.938rem',
    },
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  rightLabel: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#2e4469',
  },
  LIcon: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#7d86a9',
    paddingRight: '0.938rem',
  },
  eg7: {
    width: '50%',
    '& .MuiInputBase-input': {
      height: '3.125rem',
    },
  },
}));

const baseCssOccupieddischarge = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    // marginRight: '1.125rem',
    marginRight: '-10px',
  },
  statusBox: {
    width: '100%',
    height: '6.438rem',
    borderRadius: '0.937rem',
    backgroundColor: '#f5faff',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  columnBox: {
    flexBasis: '50%',
    height: '6.438rem',
    borderRadius: '0.937rem',
    backgroundColor: '#f5faff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  status: {
    width: '4.563rem',
    height: '4.563rem',
    borderRadius: '1.062rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.07)',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 1.25rem 0 1.563rem',
  },
  labelText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#7d86a9',
  },
  statusText: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: '#538fff',
  },
  others: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  checkBox: {
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  inputText: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    flex: '50%',
    height: '3.5rem',
    lineHeight: '3.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    backgroundColor: '#fff',
    padding: '0 1.25rem',
    color: '#2e4469',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Medium',
    '& .MuiInputBase-root': {
      height: '3.5rem',
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  discharge: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    fontWeight: '500',
    color: '#2e4469',
  },
  select: {
    '& .MuiSelect-iconOutlined': {
      color: '#538fff',
    },
  },
  bottom: {
    height: '5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  cancelBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    border: 'solid 1.5px #538fff',
    color: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
  },
  configBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
  },
  dateIcon: {
    fontSize: '1.125rem',
    color: '#538fff',
    padding: '0.8rem',
  },
  missing: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#2e4469',
  },
  grapText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
  },
  areYouSureYouWou: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#2e4469',
  },
}));

const baseCassConfirm = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    padding: '0 1.56rem',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    // marginRight: '1.125rem',
    marginRight: '-10px',
  },
  areYouSureYouWou: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    fontWeight: '500',
    color: '#2e4469',
  },
  configBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
  },
  cancelBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    border: 'solid 1.5px #4c93ff',
    color: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    background: '#f5faff',
  },
}));

const baseSetting = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    padding: '0 1.56rem',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    // marginRight: '1.125rem',
    marginLeft: '-10px',
  },
  labelText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#7d86a9',
  },
  inputText: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    fontFamily: 'NotoSans-Medium',
    flex: '50%',
    height: '3.5rem',
    lineHeight: '3.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    backgroundColor: '#fff',
    padding: '0 1.25rem',
    color: '#2e4469',
    fontSize: '1rem',
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
    },
    '& .MuiInputBase-input': {
      height: '3.5rem',
      lineHeight: '3.5rem',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  select: {
    '& .MuiSelect-iconOutlined': {
      color: '#538fff',
    },
  },
  checkBox: {
    marginLeft: '0rem',
    '& .MuiButtonBase-root': {
      padding: '0',
      paddingRight: '0.938rem',
    },
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  cancelBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    border: 'solid 1.5px #538fff',
    color: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    background: '#f5faff',
  },
  configBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
  },
  assignedBedNo: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#2e4469',
  },
  number: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#2E4469 ',
  },
}));

export { baseSetting, baseCassConfirm, baseCssBooking, baseCssOccupieddischarge };
